<template>
	<div class="cp">
        <figure class="cp-image">
            <div class="cp-badges-container"> 
                <div v-if="item.discount_percent_custom > 0" class="cp-badge-cnt">
                    <span class="cp-badge cp-badge-discount">-{{item.discount_percent_custom}}%</span>
                    <span class="cp-save"><BaseCmsLabel code="price_save" /> <span><BaseUtilsFormatCurrency :price="item.basic_price - item.price_custom" /></span></span>
                </div>                             
                <template v-if="hasSpecialBadges">
                    <template v-for="(attr, index) in item.attributes_special.filter(a => a.attribute_code === 'posebne_oznake').slice(0, 3)" :key="index">
                        <div v-if="attr.image_upload_path" class="cp-badge">
                            <figure :class="['cp-badge-image', attr.code]">
                                <BaseUiImage loading="lazy" :src="attr.image_upload_path" default="/images/no-image-50.jpg" :alt="attr.title ? attr.title : ''" />
                            </figure>
                            <div v-if="attr.title" class="cp-badge-title">{{attr.title}}</div>
                        </div>
                    </template>
                </template>
            </div>
			<NuxtLink :to="item.url_without_domain" @click="$emit('item-clicked')">
				<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width105-height90']" default="/images/no-image-105.jpg" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : ''" />
			</NuxtLink>	
		</figure>

		<div class="cp-cnt">
			<div class="cp-cnt-top">
                <div v-if="mode == 'pd' && item.manufacturer_url && item.manufacturer_url_without_domain && item.manufacturer_title" class="cp-brand">
                    <NuxtLink :to="item.manufacturer_url_without_domain" @click="$emit('item-clicked')">{{item.manufacturer_title}}</NuxtLink>
                </div>
                <h2 v-if="item.title" class="cp-title"><NuxtLink :to="item.url_without_domain" @click="$emit('item-clicked')">{{item.title}}</NuxtLink></h2>
				<CatalogSetWishlist v-if="mode != 'pd'" :item="item" />
			</div>

			<div class="cp-cnt-bottom">				                
                <div v-if="item.price_custom && item.price_custom > 0" class="cp-cnt-bottom-price">
                    <div class="cp-price">						
                        <template v-if="(item.discount_percent > 0 || item.price_custom < item.basic_price)">
                            <div class="cp-discount-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
                        </template>
                        <template v-else>
                            <div class="cp-current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
                        </template>				
                    </div>
                    <CatalogUnitPrice :item="item" mode="cp-unit" />
                    <span v-if="item.extra_price_lowest && (item.discount_percent || item.discount_percent_custom) && item.extra_price_lowest != 0" class="cp-extra-price-lowest"><BaseCmsLabel code="extra_price_lowest" />: <strong><BaseUtilsFormatCurrency :price="item.extra_price_lowest" /></strong></span>
                </div>

                <CatalogSetWishlist v-if="mode == 'pd'" :item="item" />

				<WebshopAddToCartContainer :item="item" mode="cp" />  
            </div>    
        </div>       
	</div>
</template>

<script setup>
	const props = defineProps(['item', 'mode']);

    const hasSpecialBadges = computed(() => {
        return props.item?.attributes_special?.some(a => a.attribute_code === 'posebne_oznake');
    });    
</script>